import { getRedirectContext } from '@frontend/web/utils';
import type { ParsedLocation } from '@tanstack/react-router';
import type { RouterContext } from '../../routes/__root';
import { redirect } from '../router';
import { getOnboardingRedirect, getRedirectDecision } from './redirectPolicy';

export const handleRedirectBeforeLoad = ({
  context,
  location,
}: {
  context: RouterContext;
  location: ParsedLocation;
}) => {
  const redirectContext = getRedirectContext({ context, location });
  const redirectDecision = getRedirectDecision(redirectContext);

  if (redirectDecision.action === 'redirect') {
    throw redirect({
      search: redirectDecision.search,
      to: redirectDecision.to,
    });
  }

  if (redirectDecision.action !== 'allow') {
    return;
  }

  const onboardingDecision = getOnboardingRedirect({
    description: redirectContext.description,
    membershipComplete: redirectContext.membershipComplete,
    pathname: redirectContext.pathname,
    profileComplete: redirectContext.profileComplete,
    promo: redirectContext.promo,
  });

  if (onboardingDecision.action === 'redirect') {
    throw redirect({
      search: onboardingDecision.search,
      to: onboardingDecision.to,
    });
  }
};
